import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/denntenna.github.io/denntenna.github.io/src/components/default-mdx-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Decision to Leave`}</h1>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/87bf79d3a89731af3861caf6fb693584/d00b9/decision-to-leave.webp",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.333333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/webp;base64,UklGRngAAABXRUJQVlA4IGwAAAAwBACdASoUAAsAPtFUo0uoJKMhsAgBABoJZgC7LwAByeMDhEdK92QzZAAA/vV1NuZf3AFYWFqsniwugJBmUnfFBAANBkKbLW6p2ae64ZcEp3F7nLDBLRebk85LDfFx98zs9xcJ2+iWwi4LwAA=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Book Cover",
            "title": "Book Cover",
            "src": "/static/87bf79d3a89731af3861caf6fb693584/d00b9/decision-to-leave.webp",
            "srcSet": ["/static/87bf79d3a89731af3861caf6fb693584/c85cb/decision-to-leave.webp 300w", "/static/87bf79d3a89731af3861caf6fb693584/e88ff/decision-to-leave.webp 600w", "/static/87bf79d3a89731af3861caf6fb693584/d00b9/decision-to-leave.webp 800w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`A Park Chan-Wook noir movie about a cop investigating a murder and falling in love with the prime suspect.
Partly subversive of a tropy genre and visually interesting.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      